/**
 * Shared metrics for the round blue button that closes whichever support widget is showing in
 * the bottom-right corner (HubSpot chat, the GitBook docs embed, the Userflow resource
 * center). Kept in one place so the three don't drift apart — users see them one after another
 * and any difference reads as a glitch.
 */

export const WIDGET_BUTTON_COLOR = '#0766ee'
export const WIDGET_BUTTON_COLOR_HOVER = '#0559cc'
export const WIDGET_BUTTON_SHADOW = '0 1px 6px rgba(0,0,0,0.2)'

/** Diameter, matching HubSpot's launcher. */
export const WIDGET_BUTTON_SIZE = 60
/** Distance from the bottom of the viewport. */
export const WIDGET_BUTTON_BOTTOM = 16
/** Breathing room between the button and the panel above it. */
export const WIDGET_PANEL_GAP = 8

/** Where a panel's bottom edge has to sit to clear the button. */
export const WIDGET_PANEL_BOTTOM = WIDGET_BUTTON_BOTTOM + WIDGET_BUTTON_SIZE + WIDGET_PANEL_GAP
